import * as React from "react"

export default function TableLoading() {
    return <div className="loadingTable">
        <div className="title"></div><div className="actions"></div><div className="table"></div>
    </div>
}